import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
Vue.use(Vuex);

let lastSearchId = 0;
let abortController = null; //Controlador global para cancelar solicitudes

export default {
  namespaced: true,
  state: {
    info: [],
    loader: true,
    tabla1: false,
    postulanteUnico: "",
    citasMedicas: [],
    loaderCitas: true,
  },
  getters: {
    Info(state) {
      return state.info;
    },

    Loader(state) {
      return state.loader;
    },

    LoaderCitasMedicas(state) {
      return state.loaderCitas;
    },

    Tabla1(state) {
      return state.tabla1;
    },

    Postulante(state) {
      return state.postulanteUnico;
    },

    Citas(state) {
      return state.citasMedicas;
    },
  },
  mutations: {
    llenarInfo(state, data) {
      state.info = data;
    },
    spinnerCarga(state, data) {
      state.loader = data;
    },

    spinnerCargaCitas(state, data) {
      state.loaderCitas = data;
    },

    llenarTabla1(state, data) {
      state.tabla1 = data;
    },

    llenarPostulanteUnico(state, data) {
      state.postulanteUnico = data;
    },

    llenarCitasMedicas(state, data) {
      state.citasMedicas = Array.isArray(data) ? data : [];

    },
  },
  actions: {
    async getAttributesPostulante({ commit }) {
      await axios
        .get("Postulante/ListaPostulante")
        .then((response) => {
          console.log(response.data);
          commit("llenarTabla1", true);
          commit("spinnerCarga", false);
          commit("llenarInfo", response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Swal.fire({
              title: "Tu sesión ha expirado",
              //  text: "You won't be able to revert this!",
              icon: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "VOLVER A LOGUEARSE",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload(true);
                localStorage.clear();
                this.$router.push("/");
              }
            });
          }
        });
    },

    async getAttributesPostulanteUsers({ commit }, postulante) {
      await axios
        .get("Postulante/ObtenerPostulante/" + postulante)
        .then((postulantes) => {
          console.log(postulantes.data);
          commit("llenarPostulanteUnico", postulantes.data.idPostulante);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            commit("llenarModal", true);
            Swal.fire({
              title: "Tu sesión ha expirado",
              //  text: "You won't be able to revert this!",
              icon: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "VOLVER A LOGUEARSE",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload(true);
                localStorage.clear();
                this.$router.push("/");
              }
            });
          }
        });
    },

    async editar({ dispatch }, datos) {
      //   /${this.form.idPostulante}
      console.log(datos);

      await axios.put(`Postulante/Modificar`, datos).then((data) => {
        console.log(data.data);

        if (data.data == true) {
          window.scroll(0, 0);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Realizo los cambios",
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(datos);
          dispatch("getAttributesPostulante");
          //   this.alerta = true;
          setTimeout(() => {
            // this.alerta = false;
          }, 3000);
        } else {
          window.scroll(0, 0);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Falta llenar campos",
            showConfirmButton: false,
            timer: 1500,
          });
          //   this.alerta = true;
        }
      });
    },

    async getAttributesCitasPostulante({ commit }, entrada) {
      commit("llenarCitasMedicas", []);

      commit("spinnerCargaCitas", true);

      await axios
        .get(
          `SolicitudData/ObtenerCitasMedicas?idTrabajador=${localStorage.getItem(
            "idTrabajdor"
          )}&categoria=${entrada}`
        )
        .then((response) => {
          console.log(response.data);
          commit("spinnerCargaCitas", false);
          // commit("spinnerCarga", false);

          commit("llenarCitasMedicas", response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Swal.fire({
              title: "Tu sesión ha expirado",
              //  text: "You won't be able to revert this!",
              icon: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "VOLVER A LOGUEARSE",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload(true);
                localStorage.clear();
                this.$router.push("/");
              }
            });
          }
        });
    },

    async BuscadorCitasMedicas({ commit, dispatch }, {busqueda, categoria}) {
      const searchId = ++lastSearchId; // ✅ ID único para esta búsqueda

        if (abortController) {
        abortController.abort();
        console.log("🟠 Solicitud anterior cancelada");
        }

        abortController = new AbortController();


      commit("llenarCitasMedicas", []);
      console.log(busqueda);
      if (busqueda.trim() === "") {
        lastSearchId = 0

        await dispatch("getAttributesCitasPostulante", categoria);
      } else {
        await axios
          .get(
            `SolicitudData/BusquedaCitaMedica?idTrabajador=${localStorage.getItem(
              "idTrabajdor"
            )}&busqueda=${busqueda}&categoria=${categoria}`,
            {
            signal: abortController.signal, // Conexión con AbortController
          }
          )
          .then((r) => {
            console.log(searchId, lastSearchId)
            if (searchId === lastSearchId) {
              lastSearchId = 0
              
              console.log("estamos aqui")
              commit("llenarCitasMedicas", r.data);

            }
          }).catch((error) => {
                    if (error.name === "CanceledError") {
                        console.log("Solicitud anterior cancelada");
                    } else {
                        console.error("Error al descargar el reporte:", error);
                    }
                });
      }
    },
  },
  modules: {},
};
